

export class StatusSubMenuInput implements IStatusSubMenuInput {
    /** The auto-generated id of the tbl_application_sub_menu */
    applicationSubMenuId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IStatusSubMenuInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationSubMenuId = _data["applicationSubMenuId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): StatusSubMenuInput {
        data = typeof data === 'object' ? data : {};
        let result = new StatusSubMenuInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationSubMenuId"] = this.applicationSubMenuId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IStatusSubMenuInput {
    /** The auto-generated id of the tbl_application_sub_menu */
    applicationSubMenuId: number;
    /** The updated status */
    status: number;
}

